import React, { FC } from 'react';

import { useFormikContext } from 'formik';

// components
import TextInput from '../../../../../../../components/inputs/textInput';
import AampeItalicText from '../../../../../../../components/shared/AampeText/AampeItalicText';
import styled from 'styled-components';

// constant
import aampeTheme from '../../../../../../../constants/aampeTheme';

// models
import { AttributePlaceholderFormikValues } from '../../../../../../../models/formula.model';

const AttributeDefaultValueInput: FC = () => {
    const { setFieldValue, values } =
        useFormikContext<AttributePlaceholderFormikValues>();

    return (
        <FieldContainer>
            <TitleName>
                Attribute default value <AampeItalicText text={'(Required)'} />
            </TitleName>
            <StyledTextField
                placeholder=" A text to use if we don’t have user’s attribute "
                value={values.defaultValue}
                onChange={(e) => setFieldValue('defaultValue', e.target.value)}
            />
        </FieldContainer>
    );
};

const TitleName = styled.span({
    fontSize: aampeTheme.size.font.default,
    fontWeight: 500,
    lineHeight: aampeTheme.size.lineHeight.small,
    color: aampeTheme.colors.neutral09,
});

const FieldContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(2),
});

const StyledTextField = styled(TextInput)({
    width: '100%',
    '& .MuiInputBase-root': {
        backgroundColor: aampeTheme.colors.white,
        borderRadius: aampeTheme.borderRadius.default,
        borderColor: aampeTheme.colors.bordersWG01,
        minHeight: '38px',
        '&:hover fieldset': {
            borderColor: aampeTheme.colors.solidA01,
        },
    },
});

export default AttributeDefaultValueInput;
